declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute, Params } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { v4 as uuidv4 } from 'uuid';

declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, X_BillItemsController, X_BillReceiptsController, X_BillHeaderByProviderCodeController, X_BillItemsByProviderCodeController, X_BillReceiptsByProviderCodeController, x_BillDetailsByProviderCodeRequest, BillDetailsByProviderCodeInfoController, SaveBillItemsInfoRequest2, GenericProcPostRequest, S_Methods, GetServiceProvidersRequest, ServiceProvidersController, AdmissionsByCodeController, AdmissionsByCodeRequest, AdmissionDetailsInfoController, AdmissionsHeader2, GenericParams, FTV } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbPaymentModal } from './modal/payment.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbAddDiscountModal } from './modal/adddiscount.modal';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbAddNewServiceModal } from '../profile/patientprofileview/personaldetailview/modal/addnewservice.modal';
import { NgbOPSearchProviderModal } from '../follow up/counsellingregistry/modal/opsearchprovider.modal';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../_MasterClasses/BillingClasses';






@Component({
  selector: 'IPreceiptedit_svcprovider',
  templateUrl: './IPreceiptedit_svcprovider.component.html',
  styleUrls: ['./IPreceiptedit_svcprovider.component.scss']
  , animations: [routerTransition()]
})

export class IPReceiptEditServiceProviderComponent implements OnInit {


  public ApiResData: ApiResponseModel;
  @Input() FormattedCode: string;

  public ActorCode: number = 0;
  //public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowList: boolean = true;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public LChargeEntryCode: number = 0;
  public Tdiscount: number;
  // public Tdiscount: number = 0;
  public isRequesting: boolean = false;
  public PrescriberData: PrescribingDoctor[];
  public ReferalData: ReferringDoctor[];
  public cash: boolean = false;
  public card: boolean = false;
  public cheque: boolean = false;
  public demanddraft: boolean = false;
  public ChargeEntryCode: any;
  public paytm: boolean = false;
  public FormattedCodedata: any;
  public BillStatus: any;
  public Prescribername: any;
  public Prescribercode: any;
  public Prescriberdesg: any;
  public Referalname: any;
  public ReferalCode: any;
  public Referaldesg: any;
  public NewBalance: number;
  public TotalBill: number;
  public NetPayable: number;
  public PaidTotal: number;
  public BranchName: string;
  public Date: Date;
  public Prevdisconut: number = 0;
  public Todaydisc: number = 0;
  public DiscountMode: string;
  public DiscountRemarks: string;
  public ChargeEntryCodeModal: number = 0;

  public AdmissionCode: any;
  public FacilityCode: any;

  searchTitle: string;
  // public SelectedPrescriber: PrescribingDoctor[];
  //public SelectedReferral: ReferringDoctor[];
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients(FormattedCode: string) {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Servicebillpipe, private spinner: NgxSpinnerService


  ) { }

  ngOnInit() {
    this.DiscountMode = AppData.Instance().GetDataParam('Discount Mode');
    this.Prevdisconut = 0;
    ///this.DiscountMode = 'Bill Level';
    //this.DiscountMode = AppData.Instance().GetDataParam('Discount Mode');
    this.Tdiscount = 0;

    this.FacilityCode = this.route.snapshot.paramMap.get('FacilityCodedata');
    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
    this.AdmissionCode = this.route.snapshot.paramMap.get('AdmissionCodedata');
    this.BillStatus = this.route.snapshot.paramMap.get('BillStatus');
    //alert(this.BillStatus);
    this.ChargeEntryCode = this.route.snapshot.paramMap.get('ChargeEntryCode');
    this.LoadPatients(this.FormattedCodedata);
    this.LoadAdmissionsDetails();
    this.LoadBillHeader(this.ChargeEntryCode);
    this.LoadProviderBillHeader(this.ChargeEntryCode);
    this.LoadServicesByCategory();
    this.LoadDoctorPres();
    this.LoadDoctorRef();
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  CurrentAdmissionsByCodeController: AdmissionsByCodeController[];
  CurrentAdmissionsByCodeRequest: AdmissionsByCodeRequest;
  AdmissionData: AdmissionDetailsInfoController;
  AdmissionHeader2: AdmissionsHeader2;  //take from  101029
  SelectedAdmission: AdmissionsByCodeController;
  LoadAdmissionsDetails() {
    this.CurrentAdmissionsByCodeRequest = new AdmissionsByCodeRequest();
    this.CurrentAdmissionsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetAdmissionsByCodeController();
  }

  GetAdmissionsByCodeController() {
    this.StartRefreshing();
    this.CurrentAdmissionsByCodeRequest.ConditionalOperator = 10;
    //this.CurrentAdmissionsListRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsByCodeRequest.AdmissionCode = this.AdmissionCode;
    this.CurrentAdmissionsByCodeRequest.FacilityCode = this.FacilityCode;

    this.actorservice.GetAdmissionsByCodeController(this.CurrentAdmissionsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.AdmissionData = this.ApiResData.Result;
          this.CurrentAdmissionsByCodeController = this.AdmissionData.AdmissionItems;
          this.SelectedAdmission = this.AdmissionData.AdmissionItems[0];
          //this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
          this.stopRefreshing();

          this.LoadDetailedAdmissionData();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  LoadDetailedAdmissionData() {
    /// 101029
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101029;
    getReq.Params = [
      new FTV('AdmissionNo', 'number', this.AdmissionCode)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101029;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          this.AdmissionHeader2 = JSON.parse(data)[0];
          //alert(this.AdmissionHeader2);
          //alert(this.AdmissionHeader2.IsDischargeInitiated);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  LoadBillHeaderGeneric() {
    /// 101029
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101030;
    getReq.Params = [
      new FTV('ChargeEntry', 'number', this.AdmissionHeader2.ChargeEntry)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101029;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //this.AdmissionHeader2 = JSON.parse(data)[0];
          //alert(this.AdmissionHeader2);
          //alert(this.AdmissionHeader2.IsDischargeInitiated);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  LoadBillItemsGeneric() {
    /// 101029
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101031;
    getReq.Params = [
      new FTV('ChargeEntry', 'number', this.AdmissionHeader2.ChargeEntry)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101029;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //this.AdmissionHeader2 = JSON.parse(data)[0];
          //alert(this.AdmissionHeader2);
          //alert(this.AdmissionHeader2.IsDischargeInitiated);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  CurrentServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  CurrentServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  LoadServicesByCategory() {

    this.CurrentServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
    //this.pdata2 = this.ServicesByCategoryCodeController;
    this.CurrentServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentServicesByCategoryCodeGetRequest.ServiceCategory = "0";
    this.CurrentServicesByCategoryCodeGetRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentServicesByCategoryCodeGetRequest.ConditionalOperator = 10;
    this.CurrentServicesByCategoryCodeGetRequest.PrescriberCode = this.Prescribercode;
    this.CurrentServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
    this.pdata = this.CurrentServicesByCategoryCodeController;
    this.GetServicesByCategoryCodeController();

  }
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.actorservice.GetServicesByCategoryCodeController(this.CurrentServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.CurrentServicesByCategoryCodeController = this.ApiResData.Result;
          this.pdata = this.CurrentServicesByCategoryCodeController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  CurrentX_BillHeaderByProviderCodeController: X_BillHeaderByProviderCodeController;
  CurrentX_BillItemsByProviderCodeController: X_BillItemsByProviderCodeController[];
  CurrentX_BillReceiptsByProviderCodeController: X_BillReceiptsByProviderCodeController[];

  Currentx_BillDetailsByProviderCodeRequest: x_BillDetailsByProviderCodeRequest;

  ProviderBillDataHeader: BillDetailsByProviderCodeInfoController;

  LoadProviderBillHeader(ChargeEntryCode: number) {
    this.Currentx_BillDetailsByProviderCodeRequest = new x_BillDetailsByProviderCodeRequest();
    this.Currentx_BillDetailsByProviderCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderByProviderCodeController(ChargeEntryCode);
  }
  GetX_BillHeaderByProviderCodeController(ChargeEntry: number) {
    this.Currentx_BillDetailsByProviderCodeRequest.ChargeEntry = ChargeEntry;
    this.Currentx_BillDetailsByProviderCodeRequest.ConditionalOperator = 5;
    this.actorservice.GetBillDetailsByProviderCode(this.Currentx_BillDetailsByProviderCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.ProviderBillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderByProviderCodeController = this.ProviderBillDataHeader.Header;
          this.CurrentX_BillItemsByProviderCodeController = this.ProviderBillDataHeader.Items;
          this.CurrentX_BillReceiptsByProviderCodeController = this.ProviderBillDataHeader.Receipts;
          this.NewBalance = this.CurrentX_BillHeaderByProviderCodeController.Balance;
          this.LoadDoctorPres();
          this.AddData2();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillHeaderController: X_BillHeaderController;
  CurrentX_BillItemsController: X_BillItemsController[];
  CurrentX_BillReceiptsController: X_BillReceiptsController[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader(ChargeEntryCode: number) {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController(ChargeEntryCode);
  }

  GetX_BillHeaderController(ChargeEntry: number) {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;

          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          this.CurrentX_BillItemsController = this.BillDataHeader.Items;
          this.CurrentX_BillReceiptsController = this.BillDataHeader.Receipts;
          this.NewBalance = this.CurrentX_BillHeaderController.Balance;
          this.LoadDoctorPres();
          this.AddData2();
          // this.ChargeEntryCode = this.CurrentX_BillHeaderController[0].ChargeEntry;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentPrescribingDoctor: Array<PrescribingDoctor>;
  LoadDoctorPres() {
    if (this.CurrentPrescribingDoctor == null) {
      this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
    }
    if (this.CurrentPrescribingDoctor != null) {
      var row = new PrescribingDoctor();
      let item: any = (this.CurrentX_BillItemsController && this.CurrentX_BillItemsController.length > 0)
        ? this.CurrentX_BillItemsController[0]
        : (this.CurrentX_BillItemsByProviderCodeController && this.CurrentX_BillItemsByProviderCodeController.length > 0)
          ? this.CurrentX_BillItemsByProviderCodeController[0]
          : null;
      if (item) {
        row.DoctorName = item.PrescriberName || "";
        row.DoctorCode = item.Prescriber || 0;
        row.Designation = "";
        this.CurrentPrescribingDoctor.push(row);
      }
    }
  }

  CurrentReferringDoctor: Array<ReferringDoctor>;

  LoadDoctorRef() {
    if (this.CurrentReferringDoctor == null) {
      this.CurrentReferringDoctor = new Array<ReferringDoctor>();
    }
    if (this.CurrentReferringDoctor != null) {
      var row = new ReferringDoctor();
      row.DoctorName = this.Referalname;
      row.DoctorCode = this.ReferalCode;
      row.Designation = this.Referaldesg;
      this.CurrentReferringDoctor.push(row);
    }
  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  cashdata() {
    this.cash = true;
  }
  carddata() {
    this.card = true;
  }
  chequedata() {
    this.cheque = true;
  }
  demanddraftdata() {
    this.demanddraft = true;
  }
  paytmdata() {
    this.paytm = true;
  }
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentServicesByCategoryCodeController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentServicesByCategoryCodeController,
          this.listFilter);
      }
    }
  }

  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  AddDiscount() {
    const modalRef = this.modalService.open(NgbAddDiscountModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.PreviousDiscount = this.CurrentX_BillHeaderController.Discount;
    modalRef.componentInstance.TotalBill = this.CurrentX_BillHeaderController.TotalAmount;
    modalRef.componentInstance.TodaysDiscount = this.Todaydisc;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.Tdiscount = receivedEntry.value;
      this.Todaydisc = receivedEntry.make;
      this.DiscountRemarks = receivedEntry.Remarks;
      if (this.BillStatus == 'NP') {
        this.NetPayable = this.TotalBill - this.Tdiscount;
      }
      if (this.BillStatus == 'PP') {
        this.NetPayable = this.CurrentX_BillHeaderController.Balance - this.Todaydisc;
      }
      this.NewBalance = this.CurrentX_BillHeaderController.Balance - this.Todaydisc;
    })
  }
  //docedit() {

  //    const modalRef = this.modalService.open(NgbAddBill,
  //        {
  //            centered: true,
  //            size: "lg",
  //            backdrop: 'static',
  //            keyboard: false
  //        })
  //    modalRef.componentInstance.FormattedCode = this.FormattedCodedata;
  //    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
  //        this.SelectedPrescriber = receivedEntry.make;
  //        this.SelectedReferral = receivedEntry.value;

  //       alert(this.ProvidedName);
  //    })


  //}
  CancelNewOperation() {

    this.ShowList = true;
  }
  RefreshServices() {
    this.LoadServicesByCategory();
  }
  AddNewService() {
    const modalRef = this.modalService.open(NgbAddNewServiceModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })
  }
  back() {
    this.receipt = false;
    this.opbilling = true;
    this.router.navigate(['/healins/opbilling']);
    //this.router.navigate.['/healins/opbilling'];
  }
  payment() {
    const modalRef = this.modalService.open(NgbPayBillModal,
      {
        centered: true,
        size: "lg"
      })
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  RemoveServiceProvider(l: BillDetails) {
    l.ProviderCode = null;
    l.ProviderName = null;
    this.RetainServiceCostBySelectedBranch(l);

  }
  ItemAffect(l: BillDetails) {
    l.ItemRate = l.Quantity * l.UnitPrice;
    this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
      .map((l) => +l.ItemRate)
      .reduce((sum, current) => sum + current);
    //l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);
    //this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
    //  .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;

  }
  public ProviderName: string;
  public ProviderCode: number;
  public ProviderCost: number;
  public ProviderPrice: boolean = false;
  public UnitPriceOld: boolean = true;
  ServiceProvider(l: BillDetails) {
    const modalRef = this.modalService.open(NgbOPSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.CurrentBillDetails = l;
    //l.ProviderCode = 10;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      l.ProviderName = receivedEntry.make;
      l.ProviderCode = receivedEntry.value;
      l.UnitPrice = receivedEntry.number;
      l.ItemRate = l.UnitPrice * l.Quantity;
      //alert(l.ProviderName);
      this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
        .map((l) => +l.ItemRate)
        .reduce((sum, current) => sum + current);
      //alert(this.TotalBill);
      //l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

      //this.Tdiscount = this.CurrentBillDetails.filter(l => l.rDiscount)
      //  .reduce((sum, current) => sum + current.rDiscount, 0);
      //alert(this.Tdiscount);
      this.NetPayable = this.TotalBill - this.Tdiscount;
      //alert(this.NetPayable);
      //alert(modalRef.componentInstance.CurrentBillDetails.)
    })
  }
  CurrentServiceProvidersController: ServiceProvidersController[];
  RetainServiceCostBySelectedBranch(item: BillDetails) {
    var getReq = new GetServiceProvidersRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101021;
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    //alert(this.CurrentBillDetails.ItemCode);
    getReq.ServiceCode = item.ItemCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101021;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentServiceProvidersController = JSON.parse(data);
          var l: ServiceProvidersController = this.CurrentServiceProvidersController[0];
          item.UnitPrice = l.BranchPrice;
          this.ItemAffect(item);

          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  deletedBillDetails: Array<BillDetails> = new Array<BillDetails>();
  CurrentBillDetails: Array<BillDetails>;
  AddRow(l: ServicesByCategoryCodeController) {
    if (this.CurrentBillDetails == null) {
      this.CurrentBillDetails = new Array<BillDetails>();
    }
    //var itemExists = this.CurrentBillDetails.find(x => x.ServiceDescription == l.ServiceName);
    //if (itemExists != null) {
    //  // no need to add again..!
    //  //this.CurrentBillDetails.push(item);
    //  return;
    //}
    // check if items is in deleted items list.. if exists.. remove from there.. and add to current list..
    //var itemExists = this.CurrentBillDetails.find(x => x.ServiceDescription == l.ServiceName);
    //if (itemExists != null) {
    //  return;
    //}

    var item = this.deletedBillDetails.find(x => x.ServiceDescription == l.ServiceName);
    if (item != null) {
      this.CurrentBillDetails.push(item);
      this.deletedBillDetails.splice(this.deletedBillDetails.findIndex(x => x.ServiceDescription == l.ServiceName), 1);
    }

    else // items does not exist in detled items buckeet.
    {

      var row = new BillDetails();
      row.ChargeItemID = uuidv4();
      row.Edit = false;
      row.RowNumber = row.RowNumber + 1;
      row.ServiceDescription = l.ServiceName;
      row.Quantity = 1;
      row.Discount = 0;
      row.UnitPrice = l.BasePrice;
      row.ItemRate = l.BasePrice * row.Quantity;
      row.GroupName = l.Servicecategory;
      row.PackageName = l.CategoryName;
      row.DiscountAllowed = l.DiscountAllowed;
      row.ChargeItemCode = 0;
      row.ItemCode = l.Code;
      row.ProviderName = this.ProviderName;
      row.ProviderCode = this.ProviderCode;
      this.CurrentBillDetails.push(row);

    }


    this.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current);

    this.NetPayable = this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current) - this.Tdiscount;
    //this.PaidAmount = this.NetPayable-this.Curr
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.Date = new Date();
    //        alert(l.BasePrice);

    //this.AddData();

  }
  //CurrentBillDetails: Array<BillDetails>;
  AddData2() {
    this.CurrentBillDetails = new Array<BillDetails>();
    let itemsArr: any[] = (this.CurrentX_BillItemsByProviderCodeController && this.CurrentX_BillItemsByProviderCodeController.length > 0)
      ? this.CurrentX_BillItemsByProviderCodeController
      : (this.CurrentX_BillItemsController && this.CurrentX_BillItemsController.length > 0)
        ? this.CurrentX_BillItemsController
        : [];
    itemsArr.forEach((v, i, d) => {
      var item = new BillDetails();
      item.ChargeItemID = v.ChargeItemID;
      item.Edit = false;
      item.RowNumber = i + 1;
      item.ServiceDescription = v.ItemDescription || v.ServiceName || '';
      item.Quantity = v.Quantity || 0;
      item.Discount = v.Discount || 0;
      item.UnitPrice = v.UnitPrice || 0;
      item.ItemRate = v.ItemTotal || 0;
      item.GroupName = v.ServiceCategory ? v.ServiceCategory.toString() : '';
      item.PackageName = v.ServiceCategoryName || '';
      item.DiscountAllowed = v.DiscountAllowed;
      item.ChargeItemCode = v.ChargeItemCode;
      item.ItemCode = v.ItemCode;
      item.ProviderName = v.ProviderName;
      item.ProviderCode = v.ProviderCode;
      this.CurrentBillDetails.push(item);
    });

    var hdr = (this.ProviderBillDataHeader && this.ProviderBillDataHeader.Header)
      ? this.ProviderBillDataHeader.Header
      : (this.BillDataHeader && this.BillDataHeader.Header)
        ? this.BillDataHeader.Header
        : (this.CurrentX_BillHeaderByProviderCodeController || this.CurrentX_BillHeaderController);
    if (hdr) {
      this.TotalBill = hdr.TotalAmount || hdr.ItemTotal || 0;
      this.NetPayable = hdr.Net || 0;
      this.PaidTotal = hdr.PaidTotal || hdr.Paid || 0;
      this.Tdiscount = hdr.Discount || 0;
    }
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.Date = new Date();
    this.LChargeEntryCode = this.ChargeEntryCode;
  }
  CurrentNewBillData: NewBillData;
  //AddData() {
  //  this.CurrentNewBillData = new NewBillData();
  //  this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
  //  this.CurrentNewBillData.BillDate = new Date();
  //  this.CurrentNewBillData.BillSource = "Internal";
  //  this.CurrentNewBillData.BillStatus = "";
  //  this.CurrentNewBillData.BillType = "OP";
  //  this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
  //  this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
  //  this.CurrentNewBillData.ChargeEntryCode = this.LChargeEntryCode;
  //  this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
  //  this.CurrentNewBillData.Items = this.CurrentBillDetails;
  //  this.CurrentNewBillData.DeletedItems = this.deletedBillDetails;
  //  this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
  //  this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
  //  this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
  //  this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
  //  this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
  //  this.CurrentNewBillData.TotalDiscount = this.Tdiscount;
  //  this.CurrentNewBillData.TotalBill = this.TotalBill;
  //  this.CurrentNewBillData.NetPayable = this.NetPayable;
  //  if (this.BillStatus != 'PP' && this.BillStatus != 'NP') {
  //    this.SaveData();
  //  }



  //}
  AddData() {
    this.CurrentNewBillData = new NewBillData();
    this.CurrentNewBillData.ActorCode = this.SelectedPatientFormattedCode.ActorCode;


    this.CurrentNewBillData.BillDate = new Date();
    this.CurrentNewBillData.BillSource = "Internal";
    this.CurrentNewBillData.BillStatus = "";
    this.CurrentNewBillData.BillType = "IP";
    this.CurrentNewBillData.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentNewBillData.BranchName = AppData.Instance().SelectedBranchName;
    this.CurrentNewBillData.ChargeEntryCode = this.LChargeEntryCode;
    this.CurrentNewBillData.Gender = this.SelectedPatientFormattedCode.Gender;
    this.CurrentNewBillData.Items = this.CurrentBillDetails;
    this.CurrentNewBillData.DeletedItems = this.deletedBillDetails;
    this.CurrentNewBillData.PrescriberDoctor = this.CurrentPrescribingDoctor;
    this.CurrentNewBillData.ReferringDoctor = this.CurrentReferringDoctor;
    this.CurrentNewBillData.PatientFormattedCode = this.SelectedPatientFormattedCode.FormattedCode;
    this.CurrentNewBillData.PatientName = this.SelectedPatientFormattedCode.DisplayName;
    this.CurrentNewBillData.PhoneNumber = this.SelectedPatientFormattedCode.Telephone1;
    this.CurrentNewBillData.TotalDiscount = this.Tdiscount;
    this.CurrentNewBillData.PreviousDiscount = this.Prevdisconut;
    this.CurrentNewBillData.DiscountAmount = this.Todaydisc;
    this.CurrentNewBillData.DiscountRemarks = this.DiscountRemarks;
    this.CurrentNewBillData.Discountmode = this.DiscountMode;
    this.CurrentNewBillData.TotalBill = Math.round(this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current));
    //alert(this.CurrentNewBillData.TotalBill);
    this.CurrentNewBillData.NetPayable = Math.round(this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current) - this.Tdiscount);
    //alert(this.CurrentNewBillData.NetPayable);
    //this.CurrentNewBillData
    //this.SaveData();
    this.SaveData2();

  }
  SaveData() {
    this.spinner.show();
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.LChargeEntryCode.toString();
    this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 10;
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (result.Result[0].Result > 0) {
          //if (!this.ApiResData.hasError) {

          //   if (this.ApiResData.Result > 0) {
          this.LChargeEntryCode = this.ApiResData.Result[0].Result;
          // alert(this.LChargeEntryCode);
          //this.GetActorEducationInfoController();
          //this.GetResourceIdentificationByDateInfoController();
          // alertFunctions.AlertParam('Saved Successfully.....!');
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

          // this.Listview = true;
          //this.EditEmbryo = false;
          //this.LoadStoreData();
          //this.AddEmbryo = false;
          //this.spinner.hide();
          //this.activeModal.close();
          //this.clearData();
          // this.LoadScansData();
          this.stopRefreshing();
          this.spinner.hide();
          //this.ChargeEntryCodeModal = val;
          // this.LoadBillHeader(this.LChargeEntryCode);
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");

          //this.spinner.hide();
          this.stopRefreshing();
          this.spinner.hide();
        }

      },





        (error) => {
          // alert("kkhkhjkhkjhjkh");

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  SaveData2() {
    this.spinner.show();
    var saveReq = new SaveBillItemsInfoRequest2();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40112;
    saveReq.Bill = this.CurrentNewBillData;
    if (this.LChargeEntryCode != null)
      saveReq.ChargeEntry = this.LChargeEntryCode.toString();
    else
      saveReq.ChargeEntry = '0';
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40112;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            //alert(this.ApiResData);
            //alert(this.ApiResData.Result);
            //alert(this.ApiResData.Result[0]);
            //  alert(this.ApiResData.Result[0].Result);

            this.LChargeEntryCode = parseInt(this.ApiResData.Result[0]);
            //alert(this.LChargeEntryCode);
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
            this.spinner.hide();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.spinner.hide();
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  CanCancel(): boolean {
    var billdate = new Date(this.CurrentX_BillHeaderController.BillCreatedDate);//.getDate();
    //  alert(billdate);
    var today = new Date();//.getDate();
    //  alert(today);
    if (billdate.getDate() == today.getDate() &&
      billdate.getMonth() == today.getMonth() &&
      billdate.getFullYear() == today.getFullYear()
    )
      return true; // go ahead and cancel
    else
      return false;

  }
  CancelBill() {
    if (!this.CanCancel()) {
      alertFunctions.AlertParam("Selected Bill Cannot be cancelled" + "...!" + "Only Bills that are generated today can be cancelled");
      return;
    }
    else {
      swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0CC27E',
        cancelButtonColor: '#FF586B',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonClass: 'btn btn-success btn-raised mr-5',
        cancelButtonClass: 'btn btn-danger btn-raised',
        allowOutsideClick: false,
        buttonsStyling: false
      }).then(() => {

        this.Cancel2();

        //this.DeleteActorIdentitiesMedicine(l);
        // alertFunctions.AlertParam('Delete Successfully...!');

      }, function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          swal(
            'Cancelled',
            'Remove Bill Operation Cancelled :)',
            'error'
          )
        }
      })
    }
  }
  Cancel2() {
    this.spinner.show();
    this.CurrentSaveBillItemsInfoRequest.Bill = this.CurrentNewBillData;
    this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.LChargeEntryCode.toString();
    this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 300;
    this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (result.Result[0].Result > 0) {



          this.LChargeEntryCode = this.ApiResData.Result[0].Result;

          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

          this.stopRefreshing();
          this.spinner.hide();
          this.Cancel();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");


          this.stopRefreshing();
          this.spinner.hide();
        }

      },





        (error) => {


          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }
  Qunatitychange(l: BillDetails) {


    l.ItemRate = l.Quantity * l.UnitPrice;
    this.TotalBill = this.CurrentBillDetails.filter((l) => l.ItemRate)
      .map((l) => +l.ItemRate)
      .reduce((sum, current) => sum + current);
    // l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

    //this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
    //  .map((l) => +l.rDiscount)
    // .reduce((sum, current) => sum + current);
    this.NetPayable = this.TotalBill - this.Tdiscount;

  }
  Discountchange(l: BillDetails) {


    l.rDiscount = l.Quantity * l.UnitPrice * (l.Discount / 100);

    this.Tdiscount = this.CurrentBillDetails.filter((l) => l.rDiscount)
      .map((l) => +l.rDiscount)
      .reduce((sum, current) => sum + current);
    this.NetPayable = this.TotalBill - this.Tdiscount;
  }

  //alert(this.CurrentBillDetails.length);
  // CurrentBillDetailsEdit: BillDetails;
  Editrow(l: BillDetails) {
    //this.Add = false;

    //this.Edit = true;
    l.Edit = true;
    //this.CurrentBillDetailsEdit = new BillDetails();
    //this.CurrentBillDetailsEdit.rownumber = l.rownumber;
    //this.CurrentBillDetailsEdit.ServiceDescription = l.ServiceDescription;
    //this.CurrentBillDetailsEdit.quantity = l.quantity;
    //this.CurrentBillDetailsEdit.unitprice = l.unitprice;
    //this.CurrentBillDetailsEdit.discount = l.discount;
    //this.CurrentBillDetailsEdit.ItemRate = l.ItemRate;

  }
  delete(i: number, l: BillDetails) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.deleterow(i, l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  deleterow(i: number, l: BillDetails) {
    this.CurrentBillDetails.splice(i, 1);

    // put this in deteleted items list...
    this.deletedBillDetails.push(l);

    this.TotalBill = this.CurrentBillDetails.filter((item) => item.ItemRate)
      .map((item) => +item.ItemRate)
      .reduce((sum, current) => sum + current);
    //this.Tdiscount = this.CurrentBillDetails.filter(item => item.rDiscount)
    //  .reduce((sum, current) => sum + current.rDiscount, 0);
    this.NetPayable = this.TotalBill - this.Tdiscount;
    this.Discountchange(l);

  }
  OnClear(l: BillDetails) {
    l.Edit = false;
  }
  Payment() {
    if (this.BillStatus != 'PP') {
      this.AddData();
    }
    //if (this.BillDataHeader.Header.BillStatus != 'PP') {
    //  this.AddData();
    //}
    const modalRef = this.modalService.open(NgbPaymentModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FormattedCode = this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode;
    modalRef.componentInstance.PatientImage = this.CurrentPatientInfoByFormattedCodeController[0].PatientImageFile;
    modalRef.componentInstance.PatientName = this.CurrentPatientInfoByFormattedCodeController[0].DisplayName;
    modalRef.componentInstance.Age = this.CurrentPatientInfoByFormattedCodeController[0].Age;
    modalRef.componentInstance.Gender = this.CurrentPatientInfoByFormattedCodeController[0].Gender;
    modalRef.componentInstance.Telephone1 = this.CurrentPatientInfoByFormattedCodeController[0].Telephone1;
    modalRef.componentInstance.BillDate = new Date();
    modalRef.componentInstance.TotalBill = Math.round(this.TotalBill);
    modalRef.componentInstance.NetPayable = Math.round(this.NetPayable);
    modalRef.componentInstance.Discount = this.Tdiscount;
    modalRef.componentInstance.ActorCode = this.SelectedPatientFormattedCode.ActorCode;
    modalRef.componentInstance.ChargeEntryCode = this.LChargeEntryCode;
    modalRef.componentInstance.BillStatus = this.BillStatus;
    modalRef.componentInstance.BillType = "IP";
    modalRef.componentInstance.BillType2 = "IP";
    modalRef.componentInstance.BillSource = "Internal";
    modalRef.componentInstance.BranchName = this.BranchName;
    modalRef.componentInstance.BranchCode = AppData.Instance().SelectedBranchCode;
    modalRef.componentInstance.PatientCode = this.CurrentPatientInfoByFormattedCodeController[0].PatientRegistrationNumber;
    modalRef.componentInstance.ItemsSelected = this.CurrentBillDetails;
    modalRef.componentInstance.BillStatus2 = this.BillStatus;
    if (this.DiscountMode == 'Item Level') {
      modalRef.componentInstance.Balance = this.CurrentX_BillHeaderController.Balance;
    }
    else if (this.DiscountMode == 'Bill Level') {
      modalRef.componentInstance.Balance = this.NewBalance;
    }
    modalRef.componentInstance.DiscountMode = this.DiscountMode;
    modalRef.componentInstance.PreviousDiscount = this.CurrentX_BillHeaderController.Discount;
    modalRef.componentInstance.Discountre = this.DiscountRemarks;
    modalRef.componentInstance.Prescriber = this.CurrentPrescribingDoctor;
    modalRef.componentInstance.Refferal = this.CurrentReferringDoctor;
    modalRef.result.then((val: number) => {
      this.ChargeEntryCodeModal = val;
      //this.LoadBillHeader(this.ChargeEntryCodeModal);
      this.LoadProviderBillHeader(this.ChargeEntryCodeModal);
    });

  }
  Cancel() {
    this.router.navigate(['healins/editadmission', {

      AdmissionCodedata: this.AdmissionCode,
      FormattedCodedata: this.FormattedCodedata,
      FacilityCodedata: this.FacilityCode
    }]);
  }
  opbill() {
    this.printService.printDocument2(this.SelectedPatientFormattedCode.FormattedCode, 0

    );
    this.printService.printDocument3(this.CurrentX_BillHeaderController.BillNo, 0

    );
    this.printService.printDocument("opbillSvc_Provider",
      {
        ChargeEntryData: this.LChargeEntryCode,
        PatientId: this.SelectedPatientFormattedCode.FormattedCode,
        Owner: this.SelectedPatientFormattedCode.DisplayName,
        Gender: this.SelectedPatientFormattedCode.Gender,
        Age: this.SelectedPatientFormattedCode.Age,
        BillDate: this.CurrentNewBillData.BillDate,
        BillNo: this.CurrentX_BillHeaderController.BillNo,
        Branch: this.CurrentNewBillData.BranchName,
        ReceiptFormattedCode: this.CurrentX_BillHeaderController.ReceiptFormattedCode,
        GrandTotal: this.TotalBill,
        Discount: this.Tdiscount,
        Tax: this.CurrentX_BillHeaderController.Tax,
        Net: this.NetPayable,
        Due: this.NewBalance,
        ReferralData: this.CurrentNewBillData.ReferringDoctor,

      },

    );
  }

}
//export class BillDetails {
//  public ItemCode: number;
//  public ServiceDescription: string;
//  public Quantity: number;
//  public UnitPrice: number;
//  public BranchBasePrice: number;
//  public Discount: number;
//  public ItemRate: number;
//  public RowNumber: number;
//  public Edit: boolean;
//  public ServiceCode: number;
//  public ItemType: string;
//  public ItemGroup: string;
//  public GroupName: string;
//  public IsPackage: boolean;
//  public PackageName: string;
//  public ChargeItemCode: number;
//  public DiscountAllowed: boolean;
//  public rDiscount: number;
//  public EditableCharge: boolean;
//  public RefundableAmount: number;
//  public RefundableQuantity: number;
//  public TaxPercentage: number;
//  public ProviderCode: number;
//  public ProviderName: string;
//}
//export class PrescribingDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}
//export class ReferringDoctor {
//  public DoctorName: string;
//  public DoctorCode: number;
//  public Designation: string;
//}

